import { fetchDatalakeFile } from '@/utils/datalake';

export const downloadTextFileFromDatalake = async (fileName: string, groupName: string) => {
  return fetchDatalakeFile({ fileName, groupName }, 'text');
};

export default downloadTextFileFromDatalake;
